import { useProfile } from 'hooks';

/** Return all school that admins has userGroups access */
export const useUserGroupsAvailableSchools = ({
  editOnly = false,
  isContact = false,
}: {
  /**
   * True if you want to only show schools that the user has edit access to
   * @default false
   */
  editOnly?: boolean;
  /**
   * True if you want to show schools that the user has contact access to
   * @default false
   */
  isContact?: boolean;
} = {}) => {
  const { schoolPermissions = [] } = useProfile();

  return schoolPermissions.filter((schoolPermission) => {
    return isContact
      ? schoolPermission.editExternalContacts
      : editOnly
        ? schoolPermission.editUser
        : schoolPermission.viewStudentManagement || schoolPermission.editUser;
  });
};
